import PipelineMembersAPI from 'dashboard/api/pipelines/pipelineMembers';

const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isUpdating: false,
  },
};

export const getters = {
  getMembers: _state => _state.records,
  getUIFlags: _state => _state.uiFlags,
};

export const actions = {
  get: async ({ commit }, { accountId, pipelineId }) => {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const response = await PipelineMembersAPI.get(accountId, pipelineId);
      commit('SET_MEMBERS', response.data.payload);
      return response;
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },

  update: async ({ commit }, { accountId, pipelineId, userIds }) => {
    commit('SET_UI_FLAG', { isUpdating: true });
    try {
      const response = await PipelineMembersAPI.update(accountId, pipelineId, userIds);
      return response;
    } finally {
      commit('SET_UI_FLAG', { isUpdating: false });
    }
  },
};

export const mutations = {
  SET_MEMBERS(_state, members) {
    _state.records = members;
  },

  SET_UI_FLAG(_state, flag) {
    _state.uiFlags = { ..._state.uiFlags, ...flag };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
